var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2651 10.5959C13.6807 10.5959 14.0505 10.4338 14.3747 10.1096C14.6988 9.78549 14.8609 9.41148 14.8609 8.98759C14.8609 8.56371 14.6988 8.19385 14.3747 7.87801C14.0505 7.56218 13.6807 7.40426 13.2651 7.40426C12.8495 7.40426 12.4797 7.56218 12.1555 7.87801C11.8314 8.19385 11.6693 8.56371 11.6693 8.98759C11.6693 9.41148 11.8314 9.78549 12.1555 10.1096C12.4797 10.4338 12.8495 10.5959 13.2651 10.5959ZM1.49606 15.1589V16.4804V1.51974V15.1589ZM1.49606 17.9764C1.11374 17.9764 0.76881 17.8268 0.461286 17.5276C0.153762 17.2284 0 16.8793 0 16.4804V1.51974C0 1.13742 0.153762 0.792492 0.461286 0.484968C0.76881 0.177444 1.11374 0.0236816 1.49606 0.0236816H16.4567C16.8556 0.0236816 17.2047 0.177444 17.5039 0.484968C17.8032 0.792492 17.9528 1.13742 17.9528 1.51974V4.86095H16.4567V1.51974H1.49606V16.4804H16.4567V13.1641H17.9528V16.4804C17.9528 16.8793 17.8032 17.2284 17.5039 17.5276C17.2047 17.8268 16.8556 17.9764 16.4567 17.9764H1.49606ZM10.4226 13.6628C9.85739 13.6628 9.40857 13.4966 9.07612 13.1641C8.74366 12.8316 8.57743 12.3911 8.57743 11.8426V6.18247C8.57743 5.61729 8.74366 5.17263 9.07612 4.84848C9.40857 4.52434 9.85739 4.36226 10.4226 4.36226H17.1549C17.72 4.36226 18.1689 4.52434 18.5013 4.84848C18.8338 5.17263 19 5.61729 19 6.18247V11.8426C19 12.3911 18.8338 12.8316 18.5013 13.1641C18.1689 13.4966 17.72 13.6628 17.1549 13.6628H10.4226ZM17.5039 12.1667V5.85833H10.0735V12.1667H17.5039Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletTransparent);
export default __webpack_public_path__ + "static/media/walletTransparent.8d6895b56387563fb281834873c1c6ae.svg";
export { ForwardRef as ReactComponent };